<template lang="pug">
  #cover
    .txt.clearfix
      h2(v-if="title") {{ title }}
      h3(v-if="subtitle") {{ subtitle }}
      NavSocial(v-if="nav.length", :nav="nav")
</template>

<script>
import './style.sass'
import NavSocial from '@/components/NavSocial/index.vue'

export default {
  name: 'Cover',
  props: {
    title: String,
    subtitle: String,
    nav: Array
  },
  components: {
    NavSocial
  }
}
</script>